module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h1', {
    staticClass: "h1"
  }, [_vm._v("CONTENTS")]), _vm._v(" "), _c('nav', {
    attrs: {
      "epub:type": "toc",
      "id": "toc"
    }
  }, [_c('ol', {
    staticClass: "tocol"
  }, [_c('li', {
    staticClass: "table-of-content"
  }, [_c('a', {
    attrs: {
      "href": "#/0_chapter1linyi"
    }
  }, [_vm._v("CHAPTER 1 - LIN YI")])]), _vm._v(" "), _c('li', {
    staticClass: "table-of-content"
  }, [_c('a', {
    attrs: {
      "href": "#/1_chapter2planephotonprocessor"
    }
  }, [_vm._v("CHAPTER 2 - PLANE PHOTON PROCESSOR")])]), _vm._v(" "), _c('li', {
    staticClass: "table-of-content"
  }, [_c('a', {
    attrs: {
      "href": "#/2_chapter3themagicalmagister"
    }
  }, [_vm._v("CHAPTER 3 - THE MAGICAL MAGISTER")])]), _vm._v(" "), _c('li', {
    staticClass: "table-of-content"
  }, [_c('a', {
    attrs: {
      "href": "#/3_chapter4yanyuanholygrimoireacademy"
    }
  }, [_vm._v("CHAPTER 4 - YAN YUAN HOLY GRIMOIRE ACADEMY")])]), _vm._v(" "), _c('li', {
    staticClass: "table-of-content"
  }, [_c('a', {
    attrs: {
      "href": "#/4_chapter5amazingtalent"
    }
  }, [_vm._v("CHAPTER 5 - AMAZING TALENT")])]), _vm._v(" "), _c('li', {
    staticClass: "table-of-content"
  }, [_c('a', {
    attrs: {
      "href": "#/5_chapter6primarypermissions"
    }
  }, [_vm._v("CHAPTER 6 - PRIMARY PERMISSIONS")])]), _vm._v(" "), _c('li', {
    staticClass: "table-of-content"
  }, [_c('a', {
    attrs: {
      "href": "#/6_chapter7spiritualgodsect"
    }
  }, [_vm._v("CHAPTER 7 - SPIRITUAL GOD SECT")])]), _vm._v(" "), _c('li', {
    staticClass: "table-of-content"
  }, [_c('a', {
    attrs: {
      "href": "#/7_chapter8manypeoplearestupid"
    }
  }, [_vm._v("CHAPTER 8 - MANY PEOPLE ARE STUPID")])]), _vm._v(" "), _c('li', {
    staticClass: "table-of-content"
  }, [_c('a', {
    attrs: {
      "href": "#/8_chapter9simple"
    }
  }, [_vm._v("CHAPTER 9 - SIMPLE")])]), _vm._v(" "), _c('li', {
    staticClass: "table-of-content"
  }, [_c('span', {
    attrs: {
      "href": "#/9_chapter10canonicaltechnique",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CHAPTER 10 - CANONICAL TECHNIQUE")])]), _vm._v(" "), _c('li', {
    staticClass: "table-of-content"
  }, [_c('span', {
    attrs: {
      "href": "#/10_chapter11trainingplan",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CHAPTER 11 - TRAINING PLAN")])]), _vm._v(" "), _c('li', {
    staticClass: "table-of-content"
  }, [_c('span', {
    attrs: {
      "href": "#/11_chapter12dongmenxiuling",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CHAPTER 12 - DONGMEN XIULING")])]), _vm._v(" "), _c('li', {
    staticClass: "table-of-content"
  }, [_c('span', {
    attrs: {
      "href": "#/12_chapter13spiritualtierhighranktechniquegreenlotus",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CHAPTER 13 - SPIRITUAL TIER HIGH RANK TECHNIQUE GREEN LOTUS")])]), _vm._v(" "), _c('li', {
    staticClass: "table-of-content"
  }, [_c('span', {
    attrs: {
      "href": "#/13_chapter14signup",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CHAPTER 14 - SIGN UP")])]), _vm._v(" "), _c('li', {
    staticClass: "table-of-content"
  }, [_c('span', {
    attrs: {
      "href": "#/14_chapter15divineinscriptionstaomark",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CHAPTER 15 - DIVINE INSCRIPTIONS TAO MARK!")])]), _vm._v(" "), _c('li', {
    staticClass: "table-of-content"
  }, [_c('span', {
    attrs: {
      "href": "#/15_chapter16divinedarkseal",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CHAPTER 16 - DIVINE DARK SEAL")])]), _vm._v(" "), _c('li', {
    staticClass: "table-of-content"
  }, [_c('span', {
    attrs: {
      "href": "#/16_chapter17clearance",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CHAPTER 17 - CLEARANCE")])]), _vm._v(" "), _c('li', {
    staticClass: "table-of-content"
  }, [_c('span', {
    attrs: {
      "href": "#/17_chapter18decisiveparti",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CHAPTER 18 - DECISIVE!(PART I)")])]), _vm._v(" "), _c('li', {
    staticClass: "table-of-content"
  }, [_c('span', {
    attrs: {
      "href": "#/18_chapter19decisivepartii",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CHAPTER 19 - DECISIVE!(PART II)")])]), _vm._v(" "), _c('li', {
    staticClass: "table-of-content"
  }, [_c('span', {
    attrs: {
      "href": "#/19_chapter20gongsunlan",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CHAPTER 20 - GONGSUN LAN")])]), _vm._v(" "), _c('li', {
    staticClass: "table-of-content"
  }, [_c('span', {
    attrs: {
      "href": "#/20_chapter21thevillaincomplainsfirst",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CHAPTER 21 - THE VILLAIN COMPLAINS FIRST")])]), _vm._v(" "), _c('li', {
    staticClass: "table-of-content"
  }, [_c('span', {
    attrs: {
      "href": "#/21_chapter22domineeringarrogant",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CHAPTER 22 - DOMINEERING ARROGANT!")])]), _vm._v(" "), _c('li', {
    staticClass: "table-of-content"
  }, [_c('span', {
    attrs: {
      "href": "#/22_chapter23yongchunmartialartsschool",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CHAPTER 23 - YONGCHUN MARTIAL ARTS SCHOOL")])]), _vm._v(" "), _c('li', {
    staticClass: "table-of-content"
  }, [_c('span', {
    attrs: {
      "href": "#/23_chapter24friends",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CHAPTER 24 - FRIENDS")])]), _vm._v(" "), _c('li', {
    staticClass: "table-of-content"
  }, [_c('span', {
    attrs: {
      "href": "#/24_chapter25swordfingerfirst",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CHAPTER 25 - SWORDFINGER FIRST!")])]), _vm._v(" "), _c('li', {
    staticClass: "table-of-content"
  }, [_c('span', {
    attrs: {
      "href": "#/25_chapter26occultring",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CHAPTER 26 - OCCULT RING")])]), _vm._v(" "), _c('li', {
    staticClass: "table-of-content"
  }, [_c('span', {
    attrs: {
      "href": "#/26_chapter27levelfourandthechallenge",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CHAPTER 27 - LEVEL FOUR AND THE CHALLENGE!")])]), _vm._v(" "), _c('li', {
    staticClass: "table-of-content"
  }, [_c('span', {
    attrs: {
      "href": "#/27_chapter28bloodprintparti",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CHAPTER 28 - BLOOD PRINT(PART I)")])]), _vm._v(" "), _c('li', {
    staticClass: "table-of-content"
  }, [_c('span', {
    attrs: {
      "href": "#/28_chapter29bloodprintpartii",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CHAPTER 29 - BLOOD PRINT(PART II)")])]), _vm._v(" "), _c('li', {
    staticClass: "table-of-content"
  }, [_c('span', {
    attrs: {
      "href": "#/29_chapter30prelude",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CHAPTER 30 - PRELUDE")])]), _vm._v(" "), _c('li', {
    staticClass: "table-of-content"
  }, [_c('span', {
    attrs: {
      "href": "#/30_chapter31start",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CHAPTER 31 - START")])]), _vm._v(" "), _c('li', {
    staticClass: "table-of-content"
  }, [_c('span', {
    attrs: {
      "href": "#/31_chapter32initialappearance",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CHAPTER 32 - INITIAL APPEARANCE")])]), _vm._v(" "), _c('li', {
    staticClass: "table-of-content"
  }, [_c('span', {
    attrs: {
      "href": "#/32_chapter33shock",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CHAPTER 33 - SHOCK!")])]), _vm._v(" "), _c('li', {
    staticClass: "table-of-content"
  }, [_c('span', {
    attrs: {
      "href": "#/33_chapter34martialartdualcultivation",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CHAPTER 34 - MARTIAL ART DUAL CULTIVATION")])]), _vm._v(" "), _c('li', {
    staticClass: "table-of-content"
  }, [_c('span', {
    attrs: {
      "href": "#/34_chapter35easytwowheels",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CHAPTER 35 - EASY TWO WHEELS")])]), _vm._v(" "), _c('li', {
    staticClass: "table-of-content"
  }, [_c('span', {
    attrs: {
      "href": "#/35_chapter36deathwaterparti",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CHAPTER 36 - DEATH WATER(PART I)")])]), _vm._v(" "), _c('li', {
    staticClass: "table-of-content"
  }, [_c('span', {
    attrs: {
      "href": "#/36_chapter37deathwaterpartii",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CHAPTER 37 - DEATH WATER(PART II)")])]), _vm._v(" "), _c('li', {
    staticClass: "table-of-content"
  }, [_c('span', {
    attrs: {
      "href": "#/37_chapter38first",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CHAPTER 38 - FIRST")])]), _vm._v(" "), _c('li', {
    staticClass: "table-of-content"
  }, [_c('span', {
    attrs: {
      "href": "#/38_chapter39lotusbloomingstepbystepworldbyworldparti",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CHAPTER 39 - LOTUS BLOOMING STEP BY STEP WORLD BY WORLD(PART I)")])]), _vm._v(" "), _c('li', {
    staticClass: "table-of-content"
  }, [_c('span', {
    attrs: {
      "href": "#/39_chapter40lotusbloomingstepbystepworldbyworldpartii",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CHAPTER 40 - LOTUS BLOOMING STEP BY STEP WORLD BY WORLD(PART II)")])]), _vm._v(" "), _c('li', {
    staticClass: "table-of-content"
  }, [_c('span', {
    attrs: {
      "href": "#/40_chapter41leveleight",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CHAPTER 41 - LEVEL EIGHT")])]), _vm._v(" "), _c('li', {
    staticClass: "table-of-content"
  }, [_c('span', {
    attrs: {
      "href": "#/41_chapter42changesinthesoulspace",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CHAPTER 42 - CHANGES IN THE SOUL SPACE")])]), _vm._v(" "), _c('li', {
    staticClass: "table-of-content"
  }, [_c('span', {
    attrs: {
      "href": "#/42_chapter43rakasha",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CHAPTER 43 - RAKASHA")])]), _vm._v(" "), _c('li', {
    staticClass: "table-of-content"
  }, [_c('span', {
    attrs: {
      "href": "#/43_chapter44mortalleveldivineinscriptionistrossi",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CHAPTER 44 - MORTAL LEVEL DIVINE INSCRIPTIONIST ROSSI!")])]), _vm._v(" "), _c('li', {
    staticClass: "table-of-content"
  }, [_c('span', {
    attrs: {
      "href": "#/44_chapter45andre",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CHAPTER 45 - ANDRE")])]), _vm._v(" "), _c('li', {
    staticClass: "table-of-content"
  }, [_c('span', {
    attrs: {
      "href": "#/45_chapter46secondsteptrainingplan",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CHAPTER 46 - SECOND STEP TRAINING PLAN")])]), _vm._v(" "), _c('li', {
    staticClass: "table-of-content"
  }, [_c('span', {
    attrs: {
      "href": "#/46_chapter47purifyingfireofbluelotus",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CHAPTER 47 - PURIFYING FIRE OF BLUE LOTUS")])]), _vm._v(" "), _c('li', {
    staticClass: "table-of-content"
  }, [_c('span', {
    attrs: {
      "href": "#/47_chapter48thecultivationofthescholarsrealm",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CHAPTER 48 - THE CULTIVATION OF THE SCHOLAR'S REALM")])]), _vm._v(" "), _c('li', {
    staticClass: "table-of-content"
  }, [_c('span', {
    attrs: {
      "href": "#/48_chapter49comprehension",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CHAPTER 49 - COMPREHENSION")])]), _vm._v(" "), _c('li', {
    staticClass: "table-of-content"
  }, [_c('span', {
    attrs: {
      "href": "#/49_chapter50shock",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CHAPTER 50 - SHOCK!")])]), _vm._v(" "), _c('li', {
    staticClass: "table-of-content"
  }, [_c('span', {
    attrs: {
      "href": "#/50_chapter51practice",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CHAPTER 51 - PRACTICE")])]), _vm._v(" "), _c('li', {
    staticClass: "table-of-content"
  }, [_c('span', {
    attrs: {
      "href": "#/51_chapter52maker",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CHAPTER 52 - MAKER")])]), _vm._v(" "), _c('li', {
    staticClass: "table-of-content"
  }, [_c('span', {
    attrs: {
      "href": "#/52_chapter53soulascensionberserk",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CHAPTER 53 - SOUL ASCENSION BERSERK!")])]), _vm._v(" "), _c('li', {
    staticClass: "table-of-content"
  }, [_c('span', {
    attrs: {
      "href": "#/53_chapter54openagain",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CHAPTER 54 - OPEN AGAIN")])]), _vm._v(" "), _c('li', {
    staticClass: "table-of-content"
  }, [_c('span', {
    attrs: {
      "href": "#/54_chapter55newsageparti",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CHAPTER 55 - NEW SAGE(PART I)")])]), _vm._v(" "), _c('li', {
    staticClass: "table-of-content"
  }, [_c('span', {
    attrs: {
      "href": "#/55_chapter56newsagepartii",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CHAPTER 56 - NEW SAGE(PART II)")])]), _vm._v(" "), _c('li', {
    staticClass: "table-of-content"
  }, [_c('span', {
    attrs: {
      "href": "#/56_chapter57ninegradegoldenlotus",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CHAPTER 57 - NINE-GRADE GOLDEN LOTUS")])]), _vm._v(" "), _c('li', {
    staticClass: "table-of-content"
  }, [_c('span', {
    attrs: {
      "href": "#/57_chapter58linyisstrength",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CHAPTER 58 - LIN YI'S STRENGTH")])]), _vm._v(" "), _c('li', {
    staticClass: "table-of-content"
  }, [_c('span', {
    attrs: {
      "href": "#/58_chapter59lessonsfortherestofyourlife",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CHAPTER 59 - LESSONS FOR THE REST OF YOUR LIFE!")])]), _vm._v(" "), _c('li', {
    staticClass: "table-of-content"
  }, [_c('span', {
    attrs: {
      "href": "#/59_chapter60divineremains",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CHAPTER 60 - DIVINE REMAINS")])]), _vm._v(" "), _c('li', {
    staticClass: "table-of-content"
  }, [_c('span', {
    attrs: {
      "href": "#/60_chapter61alifeofdefeat",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CHAPTER 61 - A LIFE OF DEFEAT")])]), _vm._v(" "), _c('li', {
    staticClass: "table-of-content"
  }, [_c('span', {
    attrs: {
      "href": "#/61_chapter62unexpectedresult",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CHAPTER 62 - UNEXPECTED RESULT")])]), _vm._v(" "), _c('li', {
    staticClass: "table-of-content"
  }, [_c('span', {
    attrs: {
      "href": "#/62_chapter63outstandingvictory",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CHAPTER 63 - OUTSTANDING VICTORY")])]), _vm._v(" "), _c('li', {
    staticClass: "table-of-content"
  }, [_c('span', {
    attrs: {
      "href": "#/63_chapter64themindoftheempire",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CHAPTER 64 - THE MIND OF THE EMPIRE")])]), _vm._v(" "), _c('li', {
    staticClass: "table-of-content"
  }, [_c('span', {
    attrs: {
      "href": "#/64_chapter65undercurrent",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CHAPTER 65 - UNDERCURRENT")])]), _vm._v(" "), _c('li', {
    staticClass: "table-of-content"
  }, [_c('span', {
    attrs: {
      "href": "#/65_chapter66preludesalazar",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CHAPTER 66 - PRELUDE SALAZAR")])]), _vm._v(" "), _c('li', {
    staticClass: "table-of-content"
  }, [_c('span', {
    attrs: {
      "href": "#/66_chapter67barbariancowseal1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CHAPTER 67 - BARBARIAN COW SEAL(1)")])]), _vm._v(" "), _c('li', {
    staticClass: "table-of-content"
  }, [_c('span', {
    attrs: {
      "href": "#/67_chapter68barbariancowseal2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CHAPTER 68 - BARBARIAN COW SEAL(2)")])]), _vm._v(" "), _c('li', {
    staticClass: "table-of-content"
  }, [_c('span', {
    attrs: {
      "href": "#/68_chapter69jessica",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CHAPTER 69 - JESSICA")])]), _vm._v(" "), _c('li', {
    staticClass: "table-of-content"
  }, [_c('span', {
    attrs: {
      "href": "#/69_chapter70prairiefire",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CHAPTER 70 - PRAIRIE FIRE")])]), _vm._v(" "), _c('li', {
    staticClass: "table-of-content"
  }, [_c('span', {
    attrs: {
      "href": "#/70_chapter71hubaiseal",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CHAPTER 71 - HUBAI SEAL")])]), _vm._v(" "), _c('li', {
    staticClass: "table-of-content"
  }, [_c('span', {
    attrs: {
      "href": "#/71_chapter72listofgeniuses",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CHAPTER 72 - LIST OF GENIUSES")])]), _vm._v(" "), _c('li', {
    staticClass: "table-of-content"
  }, [_c('span', {
    attrs: {
      "href": "#/72_chapter73smallsectslist",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CHAPTER 73 - SMALL SECTS LIST")])]), _vm._v(" "), _c('li', {
    staticClass: "table-of-content"
  }, [_c('span', {
    attrs: {
      "href": "#/73_chapter74thearcanaoftheancientera",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CHAPTER 74 - THE ARCANA OF THE ANCIENT ERA")])]), _vm._v(" "), _c('li', {
    staticClass: "table-of-content"
  }, [_c('span', {
    attrs: {
      "href": "#/74_chapter75greenlightsword1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CHAPTER 75 - GREEN LIGHT SWORD(1)")])]), _vm._v(" "), _c('li', {
    staticClass: "table-of-content"
  }, [_c('span', {
    attrs: {
      "href": "#/75_chapter76greenlightsword2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CHAPTER 76 - GREEN LIGHT SWORD(2)")])]), _vm._v(" "), _c('li', {
    staticClass: "table-of-content"
  }, [_c('span', {
    attrs: {
      "href": "#/76_chapter77townbrook",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CHAPTER 77 - TOWN BROOK")])]), _vm._v(" "), _c('li', {
    staticClass: "table-of-content"
  }, [_c('span', {
    attrs: {
      "href": "#/77_chapter78deceivingpotentialvalue",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CHAPTER 78 - DECEIVING POTENTIAL VALUE")])]), _vm._v(" "), _c('li', {
    staticClass: "table-of-content"
  }, [_c('span', {
    attrs: {
      "href": "#/78_chapter79qianliexian",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CHAPTER 79 - QIAN LIE XIAN")])]), _vm._v(" "), _c('li', {
    staticClass: "table-of-content"
  }, [_c('span', {
    attrs: {
      "href": "#/79_chapter80swordintentcrossing",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CHAPTER 80 - SWORD INTENT CROSSING")])]), _vm._v(" "), _c('li', {
    staticClass: "table-of-content"
  }, [_c('span', {
    attrs: {
      "href": "#/80_chapter81taobao",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CHAPTER 81 - TAOBAO")])]), _vm._v(" "), _c('li', {
    staticClass: "table-of-content"
  }, [_c('span', {
    attrs: {
      "href": "#/81_chapter82gambling",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CHAPTER 82 - GAMBLING")])]), _vm._v(" "), _c('li', {
    staticClass: "table-of-content"
  }, [_c('span', {
    attrs: {
      "href": "#/82_chapter83activatingtheruinsofthedivineart",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CHAPTER 83 - ACTIVATING THE RUINS OF THE DIVINE ART")])]), _vm._v(" "), _c('li', {
    staticClass: "table-of-content"
  }, [_c('span', {
    attrs: {
      "href": "#/83_chapter84mania",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CHAPTER 84 - MANIA")])]), _vm._v(" "), _c('li', {
    staticClass: "table-of-content"
  }, [_c('span', {
    attrs: {
      "href": "#/84_chapter85palaceinthedepthsoftheancientcity",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CHAPTER 85 - PALACE IN THE DEPTHS OF THE ANCIENT CITY")])]), _vm._v(" "), _c('li', {
    staticClass: "table-of-content"
  }, [_c('span', {
    attrs: {
      "href": "#/85_chapter86conflict",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CHAPTER 86 - CONFLICT")])]), _vm._v(" "), _c('li', {
    staticClass: "table-of-content"
  }, [_c('span', {
    attrs: {
      "href": "#/86_chapter87fighting",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CHAPTER 87 - FIGHTING")])]), _vm._v(" "), _c('li', {
    staticClass: "table-of-content"
  }, [_c('span', {
    attrs: {
      "href": "#/87_chapter88beheading",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CHAPTER 88 - BEHEADING")])]), _vm._v(" "), _c('li', {
    staticClass: "table-of-content"
  }, [_c('span', {
    attrs: {
      "href": "#/88_chapter89firecontrololdman",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CHAPTER 89 - FIRE CONTROL OLD MAN")])]), _vm._v(" "), _c('li', {
    staticClass: "table-of-content"
  }, [_c('span', {
    attrs: {
      "href": "#/89_chapter90centralzone",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CHAPTER 90 - CENTRAL ZONE")])]), _vm._v(" "), _c('li', {
    staticClass: "table-of-content"
  }, [_c('span', {
    attrs: {
      "href": "#/90_chapter91comprehensionstonetablet",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CHAPTER 91 - COMPREHENSION STONE TABLET")])]), _vm._v(" "), _c('li', {
    staticClass: "table-of-content"
  }, [_c('span', {
    attrs: {
      "href": "#/91_chapter92closetothestonetablet",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CHAPTER 92 - CLOSE TO THE STONE TABLET")])]), _vm._v(" "), _c('li', {
    staticClass: "table-of-content"
  }, [_c('span', {
    attrs: {
      "href": "#/92_chapter93desolaterealm",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CHAPTER 93 - DESOLATE REALM")])]), _vm._v(" "), _c('li', {
    staticClass: "table-of-content"
  }, [_c('span', {
    attrs: {
      "href": "#/93_chapter94divinelevelexpert",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CHAPTER 94 - DIVINE LEVEL EXPERT")])]), _vm._v(" "), _c('li', {
    staticClass: "table-of-content"
  }, [_c('span', {
    attrs: {
      "href": "#/94_chapter95conspiracy",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CHAPTER 95 - CONSPIRACY")])]), _vm._v(" "), _c('li', {
    staticClass: "table-of-content"
  }, [_c('span', {
    attrs: {
      "href": "#/95_chapter96escape",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CHAPTER 96 - ESCAPE")])]), _vm._v(" "), _c('li', {
    staticClass: "table-of-content"
  }, [_c('span', {
    attrs: {
      "href": "#/96_chapter97thestrengthofapeaklevelpowerhouse",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CHAPTER 97 - THE STRENGTH OF A PEAK-LEVEL POWERHOUSE")])]), _vm._v(" "), _c('li', {
    staticClass: "table-of-content"
  }, [_c('span', {
    attrs: {
      "href": "#/97_chapter98vibrations",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CHAPTER 98 - VIBRATIONS")])]), _vm._v(" "), _c('li', {
    staticClass: "table-of-content"
  }, [_c('span', {
    attrs: {
      "href": "#/98_chapter99areversalofpower",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CHAPTER 99 - A REVERSAL OF POWER")])]), _vm._v(" "), _c('li', {
    staticClass: "table-of-content"
  }, [_c('span', {
    attrs: {
      "href": "#/99_chapter100behindcloseddoors",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CHAPTER 100 - BEHIND CLOSED DOORS")])])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-d3bbc574","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/toc.vue
// module id = 57
// module chunks = 0